export const MIN_QUERY_LENGTH = 3;
export const SEARCH_DEBOUNCE_MS = 400;
export const MAX_VISIBLE_RESULTS = 10;
export const RESULT_ITEM_HEIGHT_PX = 48;
